/**
 * Determine if a value is nullish (undefined or null)
 * @param {*} value The value to check
 * @returns boolean
 */
function isDefined(value) {
  return value !== null && value !== undefined && typeof value !== 'undefined'
}

export {isDefined}
